export class AccountBalance {
  constructor() {
    this.type = null;
    this.amount = null;
    this.currency = null;
  }
}
export default AccountBalance;
